import useExperiments from '~/stores/useExperimentsStore';

export default function useGridLayoutConfig() {
  const {
    experimentFlags: { gridColumnLayout, gridColumnLayout2 },
  } = useExperiments();

  if (gridColumnLayout) {
    return {
      cellLeft: 'cell medium-6 large-6 xlarge-6',
      cellRight: 'cell medium-6 large-5 large-offset-1 xlarge-5 xlarge-offset-1',
    };
  }
  if (gridColumnLayout2) {
    return {
      cellLeft: 'cell medium-6 large-6 xlarge-6',
      cellRight: 'cell medium-6 large-6 large-offset-0 xlarge-6 xlarge-offset-0 large-padding-left-l',
    };
  }
  return {
    cellLeft: 'cell medium-6 large-6 xlarge-7',
    cellRight: 'cell medium-6 large-5 large-offset-1 xlarge-5 xlarge-offset-0',
  };
}
